<nes-dialog
  nes-id="someidtoo"
  [active]="isRouteDialogActive$ | async"
  (nesOnCloseClick)="closeDialog()"
  [heading]="'COMPOSE.ROUTE.TITLE' | translate"
  heading-tag="h1"
  [subtext]="'COMPOSE.ROUTE.DESCRIPTION' | translate"
>
  <div slot="content">
    <div [formGroup]="formGroup">
      <bca-choose-station
        [cypress]="'from_station'"
        [searchFn]="searchStation"
        [label]="'COMPOSE.ROUTE.FROM.LABEL' | translate"
        [stationsLoading]="stationsLoading$ | async"
        [routeLoading]="routeLoading$ | async"
        [requiredError]="hasControlError('from', 'required')"
        [selectedStation]="(configuredRoute$ | async)?.from"
        (selected)="onFromStationSelected($event)"
      >
      </bca-choose-station>
      <bca-choose-station
        [cypress]="'to_station'"
        [searchFn]="searchStation"
        [label]="'COMPOSE.ROUTE.TO.LABEL' | translate"
        [stationsLoading]="stationsLoading$ | async"
        [routeLoading]="routeLoading$ | async"
        [requiredError]="hasControlError('to', 'required')"
        [selectedStation]="(configuredRoute$ | async)?.to"
        (selected)="onToStationSelected($event)"
      >
      </bca-choose-station>
      @if (routeLoading$ | async) {
        <div class="basicLoader"></div>
      } @else {
        @if ((configuredRoute$ | async)?.price; as price) {
          @if (price) {
            <bca-route-summary
              [secondClassPrice]="price[TravelerClass.SECOND]"
              [trainFreePrice]="trainFreePrice$ | async"
            >
            </bca-route-summary>
          }
        }
      }
    </div>
    @if (checkIdenticalError() !== undefined) {
      <nes-error-message>
        {{ "COMPOSE.ROUTE.ERROR.IDENTICAL" | translate }}
      </nes-error-message>
    }
  </div>

  <div slot="button-group-footer">
    <nes-button
      [disabled]="routeLoading$ | async"
      [cypress]="'dialog_accept'"
      variant="primary"
      type="button"
      (nesOnClick)="configureRoute()"
    >
      {{ "COMPOSE.ROUTE.BUTTON.CONFIGURE" | translate }}
    </nes-button>
    <nes-button
      [disabled]="routeLoading$ | async"
      [cypress]="'dialog_decline'"
      variant="tertiary"
      class="nes-mr-3"
      type="button"
      (click)="closeDialog()"
    >
      {{ "BUTTON.CANCEL" | translate }}
    </nes-button>
  </div>
</nes-dialog>
